/*
实名认证页面相关api
 */
import axios from 'axios';
// import request from "../request"
export const realNameApi = {
  // 获取证件类型
  getCertificateTypes () {
    return axios.get('/api/s/res/id_types');
  },
  /**
   * 实名认证
   * data => {
   *
    birthday: "", //出生日期 1989-01-23
    countryCode: "", // 国籍 86
    countryName: "", // 国籍名称
    identifyImgUrl1: "", // 证件正面照
    identifyImgUrl2: "", // 证件反面照
    identifyImgUrl3: "", // 手持证件照
    identityNo: "", // 证件号码
    identityType: "", // 证件类型
    identityName: "", // 证件类型对应的文字
    nickName: "",  // 昵称
    realName: "", // 姓名
    sex: "" // 性别
   * }
   *
   */
  certification(data) {
    return axios({
      url: '/v2/u/user/certification',
      method: 'post',
      data,
    });
  },
  // 获取用户实名认证资料
  getCertificationInfo() {
    return axios.get('/v2/u/user/certification');
  },
};
